import { ROUTES } from "./routes";
import { resolveSiteUrl } from "./appConfig";

export const SITE_ORIGIN = resolveSiteUrl("https://caf-sports.com");
export const SITE_BASE_PATH = "";
export const SITE_URL = SITE_ORIGIN;

export const SEO_DEFAULTS = {
  siteName: "CAF Sports",
  themeColor: "#00a44f",
  ogImagePath: "/logoDark.svg",
  twitterHandle: "",
};

export const SEO_PAGES = {
  home: {
    path: ROUTES.home,
    titleKey: "seo.home.title",
    descriptionKey: "seo.home.description",
    keywordsKey: "seo.home.keywords",
    breadcrumbKey: "Home",
  },
  about: {
    path: ROUTES.about,
    titleKey: "seo.about.title",
    descriptionKey: "seo.about.description",
    keywordsKey: "seo.about.keywords",
    breadcrumbKey: "About Us",
  },
  projects: {
    path: ROUTES.projects,
    titleKey: "seo.projects.title",
    descriptionKey: "seo.projects.description",
    keywordsKey: "seo.projects.keywords",
    breadcrumbKey: "Our Projects",
  },
  products: {
    path: ROUTES.products,
    titleKey: "seo.products.title",
    descriptionKey: "seo.products.description",
    keywordsKey: "seo.products.keywords",
    breadcrumbKey: "Products",
  },
  productDetail: {
    path: ROUTES.products,
    titleKey: "seo.products.title",
    descriptionKey: "seo.products.description",
    keywordsKey: "seo.products.keywords",
    breadcrumbKey: "Products",
  },
  cart: {
    path: ROUTES.cart,
    titleKey: "Shopping Cart",
    descriptionKey: "seo.products.description",
    keywordsKey: "seo.products.keywords",
    breadcrumbKey: "Shopping Cart",
  },
  checkout: {
    path: ROUTES.checkout,
    titleKey: "Checkout",
    descriptionKey: "Complete your billing details to place your order.",
    keywordsKey: "seo.products.keywords",
    breadcrumbKey: "Checkout",
  },
  orderSuccess: {
    path: ROUTES.orderSuccess,
    titleKey: "Order Success",
    descriptionKey: "Your order has been received successfully.",
    keywordsKey: "seo.products.keywords",
    breadcrumbKey: "Order Success",
  },
  services: {
    path: ROUTES.services,
    titleKey: "seo.services.title",
    descriptionKey: "seo.services.description",
    keywordsKey: "seo.services.keywords",
    breadcrumbKey: "Services",
  },
  contact: {
    path: ROUTES.contact,
    titleKey: "seo.contact.title",
    descriptionKey: "seo.contact.description",
    keywordsKey: "seo.contact.keywords",
    breadcrumbKey: "Contact Us",
  },
};

export const SITEMAP_PAGES = Object.values(SEO_PAGES);
